import { Menu } from '@shared/components/Menu';
import { SortDirectionMenu } from '@shared/components/SortDirectionMenu';
import { ControlRow, SortOption } from '@shared/components/filter/types';
import { Row } from './Row';

interface SortRowProps extends ControlRow<SortOption> {
  sort: SortOption;
  availableSorts: SortOption[];
}

export function SortRow({ sort, onUpdate, onDelete, availableSorts }: SortRowProps) {
  const onSelect = (direction: SortOption['direction']) => {
    const newSortOption = { ...sort, direction };
    onUpdate(newSortOption);
  };

  return (
    <Row
      icon="arrows-up-down-swap"
      onDelete={() => onDelete({ ...sort, direction: undefined } as SortOption)}
    >
      <Menu>
        <Menu.Button label={sort.label} icon={sort.icon} />
        <Menu.Content>
          <Menu.SearchableOptions
            options={availableSorts}
            getItemKey={option => option.id}
            getItemLabel={option => option.label}
            getItemIcon={option => option.icon}
            onSelect={option => onUpdate({ ...sort, ...option })}
            isItemSelected={option => option.id === sort.id}
          />
        </Menu.Content>
      </Menu>
      <SortDirectionMenu
        direction={sort.direction}
        onSelect={onSelect}
        showButtonLabel={true}
        align="right"
      />
    </Row>
  );
}
